import { z } from 'zod';

export const CreateHotelEventSchema = z.object({
  startsOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD'),
  endsOn: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable()
    .optional(),
  title: z.string().min(2).max(160),
  // Nullable so an edit can CLEAR the description: the service already maps
  // `description ?? null`, but the schema used to reject null, which made a
  // once-written description permanent.
  description: z.string().max(2000).nullable().optional(),
  category: z.enum(['event', 'promo', 'seasonal']).default('event'),
});
export type CreateHotelEvent = z.infer<typeof CreateHotelEventSchema>;

export const UpdateHotelEventSchema = CreateHotelEventSchema.partial();
export type UpdateHotelEvent = z.infer<typeof UpdateHotelEventSchema>;

export const HotelEventSchema = z.object({
  id: z.string().guid(),
  hotelId: z.string().guid(),
  startsOn: z.string(),
  endsOn: z.string().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  category: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type HotelEvent = z.infer<typeof HotelEventSchema>;
